<template>
    <div id="how-to-works" class="flex flex-col items-center px-4 mb-8 sm:mb-12">
        <h2 class="text-xl sm:text-2xl text-san-marino-700 font-bold mb-6 sm:mb-8 text-center"
            >Kolay eSIM Nasıl Çalışır?</h2
        >
        <div class="flex flex-col md:flex-row items-center md:items-start gap-y-8 sm:gap-x-8 md:gap-x-12 lg:gap-x-20 xl:gap-x-40">
            <div class="flex flex-col gap-y-3 w-full sm:w-52">
                <NuxtImg
                    src="/first-step.svg"
                    width="196"
                    height="401"
                    loading="lazy"
                    alt="First Step of How to Works"
                    class="mx-auto" />
                <h3 class="font-semibold text-xl sm:text-2xl text-san-marino-700 text-center"
                    >Paketinizi satın alın</h3
                >
            </div>
            <div class="flex flex-col gap-y-3 w-full sm:w-52">
                <NuxtImg
                    src="/second-step.svg"
                    width="196"
                    height="401"
                    loading="lazy"
                    alt="Second Step of How to Works"
                    class="mx-auto" />
                <h3 class="font-semibold text-xl sm:text-2xl text-san-marino-700 text-center"
                    >eSIM'inizi kurun</h3
                >
            </div>
            <div class="flex flex-col gap-y-3 w-full sm:w-52">
                <NuxtImg
                    src="/third-step.svg"
                    width="196"
                    height="401"
                    loading="lazy"
                    alt="Third Step of How to Works"
                    class="mx-auto" />
                <h3 class="font-semibold text-xl sm:text-2xl text-san-marino-700 text-center"
                    >Kullanmaya anında başlayın</h3
                >
            </div>
        </div>
    </div>
</template>
